import { Container, Grid, Typography } from "@mui/material"
import { IApiFunc, IApiResult } from "auth/interface/api.interface"
import { useApi } from "auth/useApi3"
import FormCardButton from "components/Form/FormComponents/FormCardButton/FormCardButton"
import { IFormCardButtonProps } from "components/Form/FormComponents/FormCardButton/FormCardButton.interfaces"
import FormTemplate from "components/Form/FormTemplate/FormTemplate"
import { IFormTemplateProps } from "components/Form/FormTemplate/formtemplate.interface"
import { apiEndpoints } from "generated/apiEndpoints"
import { allRoutes } from "generated/routes"
import { getTemplateSettings } from "pages/deviation/pages/helpers/templateSettings"
import React, { useEffect, useMemo, useState } from "react"
import { useTranslation } from "react-i18next"
import { useHistory, useLocation } from "react-router-dom"

function useQuery() {
  const { search } = useLocation()

  return useMemo(() => new URLSearchParams(search), [search])
}

const CreateDeviation: React.FC = () => {
  const { t } = useTranslation()
  const [templateResults, getTemplates] = useApi() as [IApiResult, IApiFunc]
  const [formResult, getForm] = useApi() as [IApiResult, IApiFunc]
  const [queryParamId, setQueryParam] = useState<string | null>(null)
  const history = useHistory()

  useEffect(() => {
    getTemplates.get(apiEndpoints.form.getformtemplateminimized.replace("{feature}", "Deviation"))
  }, [getTemplates])

  let query = useQuery()
  useEffect(() => {
    getTemplates.get(apiEndpoints.form.getformtemplateminimized.replace("{feature}", "Deviation"))
  }, [getTemplates])

  useEffect(() => {
    if (query.get("id")) {
      setQueryParam(query.get("id") ?? null)
    } else {
      setQueryParam(null)
    }
  }, [query])

  useEffect(() => {
    if (queryParamId) {
      getForm.get(apiEndpoints.form.getformtemplatebyid.replace("{id}", queryParamId))
    }
  }, [getForm, queryParamId])
  return (
    <Container>
      {" "}
      {queryParamId === null && templateResults.status === 2 ? (
        <>
          <Grid container mx={"auto"} direction="row" display={"flex"} justifyContent="center">
            <Grid item>
              <Typography variant="h2" mb={2}>
                {t("deviation.what_do_you_want_to_report", "What do you want to report?")}
              </Typography>
            </Grid>
          </Grid>
          <Grid container mx={"auto"} gap={3} display={"flex"} justifyContent={"center"} p={0}>
            {templateResults.data?.map((template: IFormTemplateProps) => {
              const settings = getTemplateSettings(template.key)
              const componentProps: IFormCardButtonProps = {
                translationData: { formTypeKey: "deviation", formNameKey: template.key || "" },
                description: settings?.description,
                title: template.name,
                icon: settings?.icon,
                t: t,
                size: "2x",
                id: template.id,
                handleClick: () => {
                  history.push({
                    pathname: allRoutes.DeviationListCreate(),
                    search: `?id=${template.id}`
                  })
                }
              }
              return (
                <Grid item md={5} xs={12}>
                  <FormCardButton {...componentProps} />
                </Grid>
              )
            })}
          </Grid>
        </>
      ) : (
        queryParamId !== null &&
        formResult.status === 2 && (
          <Grid item md={12} xs={12}>
            <FormTemplate
              {...formResult.data}
              apiSubmitEndpoint={apiEndpoints.deviation.adddeviation}
              translationData={{ formTypeKey: "deviation", formNameKey: formResult.data?.key }}
            />
          </Grid>
        )
      )}
    </Container>
  )
}

export default CreateDeviation
